import { useTheme } from "styled-components";
import { Text } from "../../../Text/Text.js";
import { TextSize, TextWeight } from "../../../Text/Text.types.js";
import { DONE_TEXT_SIZE_MAP, PROGRESS_TEXT_SIZE_MAP } from "./constants.js";
import { ProgressTextContainer } from "./style.js";
import { ProgressTextProps } from "./types.js";

export const ProgressBarText = ({
    value,
    doneTitle,
    textAlign,
    suffix = "%",
    prefix,
    orientation,
    size,
    progressBarTextColor,
}: ProgressTextProps): JSX.Element => {
    const theme = useTheme();

    const doneTextProps = {
        size: DONE_TEXT_SIZE_MAP[size],
        weight: orientation === "row" ? TextWeight.SEMIBOLD : TextWeight.NORMAL,
    };

    const progressTextProps = {
        size: orientation === "row" ? TextSize.MEDIUM : PROGRESS_TEXT_SIZE_MAP[size],
        weight: orientation === "row" ? TextWeight.SEMIBOLD : TextWeight.BOLD,
    };

    return (
        <ProgressTextContainer textAlign={textAlign} orientation={orientation}>
            <Text {...progressTextProps} color={progressBarTextColor ?? theme.grayscale[90]}>
                {prefix}
                {value}
                {suffix}
            </Text>
            {doneTitle && (
                <Text {...doneTextProps} color={theme.grayscale[80]}>
                    {doneTitle}
                </Text>
            )}
        </ProgressTextContainer>
    );
};
